"use strict";
/*--------------------------------------------------------------------------------------------------------------
 *  Copyright (c) insite-gmbh. All rights reserved.
 *  Licensed under the Apache License, Version 2.0. See License.txt in the project root for license information.
 *--------------------------------------------------------------------------------------------------------------*/
const core_1 = require("@angular/core");
exports.IEXPANDABLEPANELCOLLECTIONSERVICE_TOKEN = new core_1.OpaqueToken('IExpandablePanelCollectionService');
